import { render, staticRenderFns } from "./RsaPazientePrescrizioneFarmaciComponent.vue?vue&type=template&id=535a296c&scoped=true"
import script from "./RsaPazientePrescrizioneFarmaciComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazientePrescrizioneFarmaciComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535a296c",
  null
  
)

export default component.exports